export enum AudienceShopStatus {
  QuantityPending = 1,
  QuantityFailed,
  QuantityUpdated,
}
